import React from 'react'
import LeftMenu from './LeftMenu'
import SearchBox from './SearchBox'

import logo from '../../assets/logo_no_footer.svg'
import { Link, useHistory } from "react-router-dom";

export default function TopMenu() {

  const history = useHistory()
  const isHome = history.location.pathname === '/home/dossiers'
  return (
    <div className="top_bar">
      <div className="top_bar_container">
        <div className="top_bar_logo" >
          <LeftMenu />
          <h1 id={"hhh"}>{ isHome ? 'Mes dossiers' : 'mon compte'}</h1>
        </div>
        <Link to={"/"} style={{ marginTop: "10px" }} >
          <img src={logo} alt={"tp"} width={"105px"} height={"95px"} />
        </Link>
          {isHome ?
        <div>
            <SearchBox /> 
        </div>
            : null}
      </div>
    </div>
  )
}

